import type {ReactElement} from 'react';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {QRPayloadField} from '@Libraries/qr-code/qr-code.types';
import type {QRPhoneNumberFieldProps} from './qr-phone-number-field.types';

export function QRPhoneNumberField({value, issues, onValueChange}: QRPhoneNumberFieldProps): ReactElement {
  return (
    <QRField
      label={window.i18next.t('pmwjs_qr_generator_phone_label')}
      placeholder={window.i18next.t('pmwjs_qr_generator_phone_placeholder')}
      helpText={window.i18next.t('pmwjs_qr_generator_phone_help')}
      value={value}
      field={QRPayloadField.PHONE_NUMBER}
      issues={issues}
      onValueChange={onValueChange}
    />
  );
}
